import { Accordion } from "react-bootstrap";
import styled from "styled-components";
import { FareZoneExportAccordion } from "./FareZoneExportAccordion";
import { MasterExportAccordion } from "./MasterExportAcordion";
import { MasterParticipatingBusOperatorAccordian } from "./MasterParticipatingBusOperatorAccordian";
import { NaptanAllZonesReportAccordian } from "./NaptanExportAllZonesAccordian";
import { NaptanWithinAZoneReportAccordian } from "./NaptanExportWithinAZoneAccordian";
import SchemeCoordinatorReportAccordian from "./SchemeCoordinatorReportAccordian";
import FareChangesReportAccordian from "./FareChangesReportAccordian";
import { useContext } from "react";
import { AlertContext } from "../alert/AlertContext";
import FareZoneService from "../../services/FareZoneService";

const PageContainer = styled.div`
  padding: 15px;
  width: 100%;
  height: 100%;
`;

export const ExportReports = () => {
  const alertContext = useContext(AlertContext);
  if (!alertContext) return <></>;

  const fareZoneService = new FareZoneService(alertContext.showAlert);

  return (
    <PageContainer>
      <h3>Plus Bus Data Exports</h3>

      <Accordion alwaysOpen>
        <FareZoneExportAccordion />
        <MasterParticipatingBusOperatorAccordian />
        <MasterExportAccordion />
        {/* Not currently working */}
        {/* <NaptanAllZonesReportAccordian /> */}
        <NaptanWithinAZoneReportAccordian />
        <SchemeCoordinatorReportAccordian />
        <FareChangesReportAccordian fareZoneService={fareZoneService} />
      </Accordion>
    </PageContainer>
  );
};
